import { FC } from 'react'
import { ReportTable } from './ReportTable'

const ReportMain: FC = () => {
  return <ReportTable className='mb-5 mb-xl-8' />
}

export { ReportMain }
